export { default } from './BadgeCDS';
export { BadgeColorVariant, BadgeType } from './BadgeCDS.constants';
